import * as React from 'react';
import {WithStyles, withStyles,} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import { EditActionStyle } from '../EditAction.style';
import { IScheduleTemplate } from '@app-types/websocket/schedule.types';
import { scheduleTemplates } from './WizardCalc';
import TemplateCalendar from './TemplateExample';

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof EditActionStyle> {
  offset:number
  selectedTemplate:IScheduleTemplate;
  localization: 'se'|'en';
  selectTmplate:(template:IScheduleTemplate) => void;
}

class WizardTemplate extends React.Component<IProps> {


  public render() {
    const {classes, selectedTemplate, offset} = this.props;

    const primaryColor = "#ef5a62";
    const secondaryColor = "#acc3f2";

    return (
      <div className={classes.pane+" "+classes.paneStep} style={{ left: (offset*100)+"%", opacity:offset===0?1:0}}>
        {scheduleTemplates.map((template, index) => 
          <TemplateCalendar
            selected={template.title === selectedTemplate.title}
            key={index}
            template={template}
            colorA={primaryColor}// {firstParent.color}
            colorB={secondaryColor}// {secondParent.color}
            monthView={true}
            localization={this.props.localization}
            onSelectTemplate={(te:IScheduleTemplate) => this.props.selectTmplate(te)}
          />)}
      </div>
    );
  }

}

export default withStyles(EditActionStyle)(WizardTemplate);



// WEBPACK FOOTER //
// ./src/components/calendar2/editPane/editActions/Wizard/WizardTemplate.tsx